export default __webpack_public_path__ + "static/media/thinking_face.0b55d66a.png";